"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _PopularCss = _interopRequireDefault(require("./Popular.css.js"));

var _radium = _interopRequireDefault(require("radium"));

var _CardDeck = _interopRequireDefault(require("./CardDeck"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popular = function Popular(_ref) {
  var feedData = _ref.feedData,
      styleVariants = _ref.styleVariants;
  var fullRowTitleStyle = Object.assign({}, _PopularCss.default['contentTitleSpan'], styleVariants['contentTitleSpan']);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "popular-blogfeed-component",
    style: _PopularCss.default.component
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _PopularCss.default.componentContent
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _PopularCss.default.contentTitle
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: fullRowTitleStyle
  }, "Popular")), /*#__PURE__*/_react.default.createElement(_CardDeck.default, {
    data: feedData,
    styleVariants: styleVariants
  })));
};

var _default = (0, _radium.default)(Popular);

exports.default = _default;

//# sourceMappingURL=Popular.jsx.map